/* ============================================
   D3KR FUTURISTIC THEME - Custom Animations
   ============================================ */

(function() {
  'use strict';

  // --- Scroll-triggered animations ---
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.1
  };

  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('d3kr-visible');
        scrollObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  function initScrollAnimations() {
    document.querySelectorAll('.d3kr-animate').forEach(el => {
      scrollObserver.observe(el);
    });
  }

  // --- Parallax effect for hero sections ---
  function initParallax() {
    const heroElements = document.querySelectorAll('[data-d3kr-parallax]');
    if (!heroElements.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.pageYOffset;
          heroElements.forEach(el => {
            const speed = parseFloat(el.dataset.d3krParallax) || 0.3;
            const yPos = -(scrollY * speed);
            el.style.transform = `translate3d(0, ${yPos}px, 0)`;
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // --- Ammo counter number animation ---
  function initCounterAnimation() {
    const counters = document.querySelectorAll('[data-d3kr-counter]');
    if (!counters.length) return;

    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => counterObserver.observe(counter));
  }

  function animateCounter(element) {
    const target = parseInt(element.dataset.d3krCounter, 10);
    const duration = parseInt(element.dataset.d3krDuration, 10) || 2000;
    const start = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);

      element.textContent = current.toString().padStart(
        target.toString().length, '0'
      );

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  // --- Magnetic hover effect for CTA buttons ---
  function initMagneticButtons() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if ('ontouchstart' in window) return;

    document.querySelectorAll('.d3kr-magnetic').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.15}px, ${y * 0.15}px)`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'translate(0, 0)';
        btn.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      });

      btn.addEventListener('mouseenter', () => {
        btn.style.transition = 'none';
      });
    });
  }

  // --- Typing effect for headlines ---
  function initTypingEffect() {
    const typingElements = document.querySelectorAll('[data-d3kr-typing]');
    if (!typingElements.length) return;

    const typingObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          typeText(entry.target);
          typingObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    typingElements.forEach(el => typingObserver.observe(el));
  }

  function typeText(element) {
    const text = element.dataset.d3krTyping || element.textContent;
    const speed = parseInt(element.dataset.d3krTypingSpeed, 10) || 50;
    element.textContent = '';
    element.style.visibility = 'visible';

    let i = 0;
    function type() {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(type, speed);
      }
    }
    type();
  }

  // --- Header scroll behavior ---
  function initHeaderEffects() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.classList.add('d3kr-header-scrolled');
      } else {
        header.classList.remove('d3kr-header-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // --- Initialize all on DOM ready ---
  function init() {
    initScrollAnimations();
    initParallax();
    initCounterAnimation();
    initMagneticButtons();
    initTypingEffect();
    initHeaderEffects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
